import React from "react";
import { Link } from "react-router-dom";
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Tooltip, Paper, } from "@material-ui/core";
import { Settings } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import { DeleteButtonWithModal } from "frontend/src/ui/delete-button-with-modal";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts/index";
import { useDeleteDevice, useDevices } from "frontend/src/domain/devices";
import { useTimetables } from "frontend/src/domain/timetables";
import { paths } from "frontend/src/pages/paths/index";
import { TableRowsSkeleton } from "frontend/src/ui/table-skeleton";
import { DeviceActivation } from "./device-activation";
var Row = function (_a) {
    var _b, _c;
    var id = _a.id, title = _a.title, timetableId = _a.timetableId;
    var timetables = useTimetables();
    var timetable = (_b = timetables.data) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.id === timetableId; });
    var timetableTitle = (_c = timetable === null || timetable === void 0 ? void 0 : timetable.title) !== null && _c !== void 0 ? _c : "Без сетки вещания";
    var mutate = useDeleteDevice().mutate;
    var remove = function () { return mutate(id); };
    return (React.createElement(TableRow, null,
        React.createElement(TableCell, null, title !== null && title !== void 0 ? title : "Без названия"),
        React.createElement(TableCell, null, timetables.isLoading ? React.createElement(Skeleton, { width: 30 }) : timetableTitle),
        React.createElement(TableCell, null,
            React.createElement(Tooltip, { title: "Управление и настройки" },
                React.createElement(Link, { to: paths.business.owner.devices.settings(id) },
                    React.createElement(IconButton, { size: "small" },
                        React.createElement(Settings, null))))),
        React.createElement(TableCell, null,
            React.createElement(DeleteButtonWithModal, { onDelete: remove, message: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \"".concat(title, "\"?") }))));
};
var DevicesTable = function () {
    var _a, _b, _c;
    var devices = useDevices();
    if (((_a = devices.data) === null || _a === void 0 ? void 0 : _a.length) === 0) {
        return null;
    }
    return (React.createElement(TableContainer, { component: Paper },
        React.createElement(Table, null,
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, null, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                    React.createElement(TableCell, null, "\u0421\u0435\u0442\u043A\u0430 \u0432\u0435\u0449\u0430\u043D\u0438\u044F"),
                    React.createElement(TableCell, { width: "5%" }, null),
                    React.createElement(TableCell, { width: "5%" }, null))),
            React.createElement(TableBody, null, (_c = (_b = devices.data) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
                var id = _a.id, title = _a.title, timetableId = _a.timetableId;
                return (React.createElement(Row, { key: id, id: id, title: title, timetableId: timetableId }));
            })) !== null && _c !== void 0 ? _c : React.createElement(TableRowsSkeleton, { rows: 2, columns: 5 })))));
};
var Page = function () { return (React.createElement(Box, null,
    React.createElement(DeviceActivation, null),
    React.createElement(Box, { mt: 3 },
        React.createElement(DevicesTable, null)))); };
export var DevicesPage = function () { return (React.createElement(BusinessOwnerLayout, null,
    React.createElement(Page, null))); };
